/**
 * Constantes para el módulo de Servicios de campo
 */

export const SERVICE_STATUS = {
  PENDING: "PENDING",
  SCHEDULED: "SCHEDULED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  POSTPONED: "POSTPONED",
};

export const STATUS_COLORS = {
  [SERVICE_STATUS.PENDING]: "#fbc02d",
  [SERVICE_STATUS.SCHEDULED]: "#0288d1",
  [SERVICE_STATUS.IN_PROGRESS]: "#1976d2",
  [SERVICE_STATUS.COMPLETED]: "#43a047",
  [SERVICE_STATUS.CANCELLED]: "#e53935",
  [SERVICE_STATUS.POSTPONED]: "#8d6e63",
};

export const STATUS_LABELS = {
  [SERVICE_STATUS.PENDING]: "Pendiente",
  [SERVICE_STATUS.SCHEDULED]: "Programado",
  [SERVICE_STATUS.IN_PROGRESS]: "En curso",
  [SERVICE_STATUS.COMPLETED]: "Completado",
  [SERVICE_STATUS.CANCELLED]: "Cancelado",
  [SERVICE_STATUS.POSTPONED]: "Pospuesto",
};

export const SERVICE_TYPES = [
  { value: "INSTALACION", label: "Instalación" },
  { value: "MANTENIMIENTO", label: "Mantenimiento" },
  { value: "REPARACION", label: "Reparación" },
  { value: "INSPECCION", label: "Inspección" },
  { value: "CONSULTORIA", label: "Consultoría" },
  { value: "ENTREGA", label: "Entrega" },
  { value: "SOPORTE", label: "Soporte técnico" },
  { value: "EMERGENCIA", label: "Emergencia" },
  { value: "SUPERVISION", label: "Supervisión" },
  { value: "OTRO", label: "Otro" },
];

/** Tipo recurrente usado en reportes de distribución (visitas periódicas) */
export const RECURRING_SERVICE_TYPE = "MANTENIMIENTO";

export const SERVICE_TYPE_LABELS = Object.fromEntries(
  SERVICE_TYPES.map(({ value, label }) => [value, label])
);

export const SERVICE_TYPE_VALUES = SERVICE_TYPES.map(({ value }) => value);

export const FREQUENCY_TYPES = [
  { value: "UNICO", label: "Único" },
  { value: "MENSUAL", label: "Mensual" },
];

export const DEFAULT_FORM_VALUES = {
  client: "",
  branch: "",
  technicians: [],
  date: "",
  hour: "",
  type: "",
  status: SERVICE_STATUS.PENDING,
  notes: "",
  frequency: "",
  contactName: "",
  contactEmail: "",
  contactPhone: "",
};
